import { Space } from "antd";
import React from "react";
import { SectionCardWrapper } from "../../../Components/UI/SectionCardWrapper";
import { SectionCardHeading } from "./style";
import "./style.css";
import { withScroll } from "../../../HOC/withScroll";
import { Wrapper } from "../../../Constant";
import { PolicyDetails } from "../CommonData";
import { useLocation } from "react-router-dom";

const ThankyouPage = () => {
  const location = useLocation();
  const { transactionId, isAcceptedType } = location?.state || {};

  const {
    proposerFirstName,
  } = PolicyDetails();
  return (
    <>
      <div
        className="container"
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "150px",
        }}
      >
        <Wrapper>
          <SectionCardWrapper>
            <div className="container">
              <Space direction="vertical">
                <SectionCardHeading>
                  Hi {proposerFirstName},
                </SectionCardHeading>
                {transactionId ? (
                  <label style={{ display: "block" }}>
                    You have successfully Paid the Amount <br /> Your
                    transactionId is -: {transactionId}
                  </label>
                ) : (isAcceptedType ? (<label style={{ display: "block" }}>
                    {"Your acceptance has been recorded, please visit us after sometime for updates."}
                  </label>) : (<label style={{ display: "block" }}>
                    {"You have successfully uploaded your documents. Your documents under review"}
                  </label>)
                )}
              </Space>
            </div>
          </SectionCardWrapper>
        </Wrapper>
      </div>
    </>
  );
};

export default withScroll(ThankyouPage);
